class ClBlogList extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const button = target.closest('[data-next]');
      if (!button) return;
      event.preventDefault();
      this.loadMore(button);
    });
  }

  async loadMore(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    const hiddenCards = [...this.querySelectorAll('[data-mobile-hidden]')];
    if (matchMedia('(width < 48rem)').matches && hiddenCards.length) {
      hiddenCards.forEach((card) => card.removeAttribute('data-mobile-hidden'));
      this.announce(hiddenCards.length);
      hiddenCards[0]?.querySelector('a')?.focus();
      if (button.dataset.hasNext !== 'true') button.closest('.cl-actions')?.remove();
      return;
    }

    if (button.dataset.hasNext !== 'true') {
      button.closest('.cl-actions')?.remove();
      return;
    }

    button.setAttribute('aria-disabled', 'true');
    try {
      const url = new URL(button.href, location.href);
      url.searchParams.set('section_id', this.dataset.section ?? '');
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Blog request failed: ${response.status}`);
      const html = await response.text();
      const document = new DOMParser().parseFromString(html, 'text/html');
      const cards = [...document.querySelectorAll('[data-list] > *')];
      cards.forEach((card) => card.removeAttribute('data-mobile-hidden'));
      this.querySelector('[data-list]')?.append(...cards);
      this.announce(cards.length);
      cards[0]?.querySelector('a')?.focus();

      const nextButton = document.querySelector('[data-next][data-has-next="true"]');
      if (nextButton) {
        button.href = nextButton.href;
        button.dataset.hasNext = 'true';
        button.removeAttribute('aria-disabled');
      } else {
        button.closest('.cl-actions')?.remove();
      }
    } catch {
      location.href = button.href;
    }
  }

  announce(count) {
    const status = this.querySelector('[data-load-status]');
    if (status) status.textContent = (this.dataset.statusTemplate ?? '%count%').replace('%count%', String(count));
  }
}

customElements.get('cl-blog-list') || customElements.define('cl-blog-list', ClBlogList);
